import React, { useRef } from "react";

const MobileNumber = ({ phoneDigits, setPhoneDigits }) => {
   const inputRefs = useRef([]);
   const handleChange = (i, val) => {
    if (val && !/^\d$/.test(val)) return;

    const updated = [...phoneDigits];
    updated[i] = val;
    setPhoneDigits(updated);

    if (val && i < phoneDigits.length - 1) {
      inputRefs.current[i + 1]?.focus();
    }
  };

  const handleKeyDown = (i, e) => {
    if (e.key === "Backspace") {
      if (!phoneDigits[i] && i > 0) {
        e.preventDefault();
        const prev = [...phoneDigits];
        prev[i - 1] = "";
        setPhoneDigits(prev);
        inputRefs.current[i - 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const nums = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 10);
    const updated = phoneDigits.map((d, i) => nums[i] ?? d);
    setPhoneDigits(updated);
    const nextEmpty = updated.findIndex((d) => !d);
    const focusIdx = nextEmpty === -1 ? 9 : nextEmpty;
    inputRefs.current[focusIdx]?.focus();
  };

  return (
    <div style={{ width: "100%", padding: "0 12px", boxSizing: "border-box" }}>
    <div className="d-flex justify-content-center mb-3">
    <label className="form-label fw-bold mb-2"> Enter 10-Digit Mobile Number</label>

  </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 6,
          maxWidth: 380,
          margin: "0 auto",
        }}
      >
        {phoneDigits.map((digit, i) => (
          <input
            key={i}
            ref={(el) => (inputRefs.current[i] = el)}
            type="text"
            inputMode="numeric"
            autoComplete="off"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(i, e.target.value)}
            onKeyDown={(e) => handleKeyDown(i, e)}
            onPaste={handlePaste}
            style={{
              flex: "1 1 0",
              maxWidth: 36,
              aspectRatio: "1",
              fontSize: 18,
              textAlign: "center",
              border: "1.5px solid #ccc",
              borderRadius: 8,
              outline: "none",
              transition: "border-color 0.2s",
              boxSizing: "border-box",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#4a90e2")}
            onBlur={(e) => (e.target.style.borderColor = "#ccc")}
          />
        ))}
      </div>
    </div>
  );
};

export default MobileNumber;